export const ACCORDION_SKELETON_AMOUNT = 3;
